const initialState = {
  filterLoader: false,
  plumProSavedFilters: [],
  xoxoCodeSavedFilter: [],
  xoxoPointSavedFilter: [],
  xoxoLinkSavedFilter: [],
  xoxoCodeCampaign: [],
  adminList: [],
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESTORE_REDUX_STATE":
      return {
        ...initialState,
      };

    case "UPDATE_FILTER_LOADER":
      return {
        ...state,
        filterLoader: action.payload,
      };

    case "UPDATE_PLUM_PRO_FILTER":
      return {
        ...state,
        plumProSavedFilters: action.payload,
      };

    case "UPDATE_XOXO_CODE_FILTER":
      return {
        ...state,
        xoxoCodeSavedFilter: action.payload,
      };

    case "UPDATE_XOXO_POINT_FILTER":
      return {
        ...state,
        xoxoPointSavedFilter: action.payload,
      };

    case "UPDATE_XOXO_LINK_FILTER":
      return {
        ...state,
        xoxoLinkSavedFilter: action.payload,
      };

    case "UPDATE_XOXO_CODE_CAMPAIGN":
      return {
        ...state,
        xoxoCodeCampaign: action.payload,
      };

    case "UPDATE_ADMIN_LIST":
      return {
        ...state,
        adminList: action.payload,
      };

    default:
      return state;
  }
};

export default reportReducer;
